<div class="d-flex" id="wrapper">
    <admin-sidebar></admin-sidebar>

    <div id="page-content-wrapper">

        <admin-navigation></admin-navigation>

        <div class="container-fluid">
            <div class="d-flex mt-5 mb-5">
                <h3 class="font-weight-bold page-title mr-auto">Push Notifications</h3>
            </div>

            <!-- Success Submit Message -->
            <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="submitSuccess">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="submitSuccess = !submitSuccess">
                <span aria-hidden="true">&times;</span>
                <span class="sr-only">Close</span>
                </button>
                Notification was successfully sent!
            </div>

            <!-- Error Message -->
            <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="error">
                <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="error = !error">
                <span aria-hidden="true">&times;</span>
                <span class="sr-only">Close</span>
                </button>
                Error sending notification
            </div>

            <div class="row px-3">
                <div class="col-12 bg-white shadow-sm p-3">
                    <form [formGroup]="notificationForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <input 
                                type="text" 
                                class="form-control w-50"
                                formControlName="labelText"
                                [ngClass]="{'is-invalid': (submitted && notificationForm.invalid && f.labelText.invalid) || (f.labelText.dirty && f.labelText.invalid)}"
                            >
                        </div>

                        <div class="form-group">
                            <textarea 
                                cols="30" 
                                rows="7" 
                                class="form-control"
                                formControlName="notificationText"
                                [maxlength]="noticationTextMaxLength"
                                [ngClass]="{'is-invalid': (submitted && notificationForm.invalid && f.notificationText.invalid) || (f.notificationText.dirty && f.notificationText.invalid)}"
                            ></textarea>
                            <small id="helpId" class="text-muted pull-right">{{ (f.notificationText.value) ? f.notificationText.value.length : 0 }}/{{ noticationTextMaxLength }}</small>
                        </div>
    
                        <button [disabled]="disableSubmit" class="btn btn-primary add-button">Send Notification</button>
                    </form>
                </div>
            </div>

        </div>

        <!-- Modal Loader -->
        <modal-loader [modalText]="modalText"></modal-loader>

    </div>
</div>